module.exports = __webpack_public_path__ + "img/ic_list_arrow.da1f49ea.svg";